import * as G from '../../helpers';
import * as GC from '../../constants';
//////////////////////////////////////////////////

export const TEL_MODE = 'TEL_MODE';
export const ROUTE_BUILDER_PADDING_BOTTOM = 20;
export const TEL_INDEX_IN_ROUTE = 'indexInRoute';
export const ORIGINAL_ROUTE_GUID = GC.FIELD_ORIGINAL_ROUTE_GUID;
export const ORIGINAL_ROUTE_NAME = 'originalRouteName';
export const PLANNER_TEL_MODES = {
  ALL_EXPANDED: 'ALL_EXPANDED',
  ALL_COLLAPSED: 'ALL_COLLAPSED',
  INBOUND: GC.EDI_DIRECTION_TYPE_INBOUND,
  OUTBOUND: GC.EDI_DIRECTION_TYPE_OUTBOUND,
};

// VIEW
export const COLLAPSED = 'COLLAPSED';
export const FULL_SCREEN = 'FULL_SCREEN';
export const HALF_SCREEN = 'HALF_SCREEN';
export const STICKED_RIGHT = 'STICKED_RIGHT';

export const DIVIDER_SIZE = 5;
export const TOOLBAR_HEIGHT = 25;
export const DEFAULT_LIST_PANE_HEIGHT = 300;
export const PLANNER_UI_SETTINGS_STORAGE_KEY = 'amousDispatchPlannerUISettings';

export const switcherOptions = [
  {
    width: 55,
    value: PLANNER_TEL_MODES.INBOUND,
    name: G.getWindowLocale('titles:inbound', 'Inbound'),
  },
  {
    width: 55,
    value: PLANNER_TEL_MODES.OUTBOUND,
    name: G.getWindowLocale('titles:outbound', 'Outbound'),
  },
  {
    width: 40,
    value: PLANNER_TEL_MODES.ALL_EXPANDED,
    name: G.getWindowLocale('titles:all', 'All'),
  },
];

export const switcherIndexMap = {
  [PLANNER_TEL_MODES.INBOUND]: 0,
  [PLANNER_TEL_MODES.OUTBOUND]: 1,
  [PLANNER_TEL_MODES.ALL_EXPANDED]: 2,
  [PLANNER_TEL_MODES.ALL_COLLAPSED]: 2,
};

export const tabModeMap = {
  0: PLANNER_TEL_MODES.ALL_EXPANDED,
  1: PLANNER_TEL_MODES.ALL_EXPANDED,
  2: PLANNER_TEL_MODES.INBOUND,
  3: PLANNER_TEL_MODES.OUTBOUND,
};
// VIEW
